import { render, staticRenderFns } from "./DeliveryGroupFilter.vue?vue&type=template&id=2f66cefc&"
import script from "./DeliveryGroupFilter.vue?vue&type=script&lang=js&"
export * from "./DeliveryGroupFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports